import React, { Fragment } from "react";
import FeatureTitleCell from "../FeatureTitleCell";
import CellEntitlement from "../CellEntitlement";

const FeatureEntitlementsRow = ({
  tracking,
  activeIndex,
  provided,
  snapshot,
  feature,
  featureGroup,
  products,
  thWidth,
  tdWidth
}) => {
  return (
    <Fragment>
      <tr
        className="dt-row"
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <FeatureTitleCell
          tracking={tracking}
          provided={provided}
          snapshot={snapshot}
          feature={feature}
          featureGroup={featureGroup}
          products={products}
          thWidth={thWidth}
        />
        {products.map((product, tableProductIx) => {
          return (
            <CellEntitlement
              tracking={tracking}
              provided={provided}
              snapshot={snapshot}
              tdWidth={tdWidth}
              key={tableProductIx}
              product={product}
              productIndex={tableProductIx}
              activeIndex={activeIndex}
              feature={feature}
              featureGroup={featureGroup}
            />
          );
        })}
      </tr>
      {provided.placeholder && (
        <tr>
          <td colSpan={4} className="bl br hairline-1 bb br--bottom br2">
            <div style={{ height: 54 }} className="bg-white"></div>
          </td>
        </tr>
      )}
    </Fragment>
  );
};

export default FeatureEntitlementsRow;
